module.exports = __webpack_public_path__ + "img/AdultSignatureNA.63a0ffb5.svg";